import { render, staticRenderFns } from "./supporting-material.vue?vue&type=template&id=1d2d9be6&"
import script from "./supporting-material.vue?vue&type=script&lang=ts&"
export * from "./supporting-material.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports